/**
 * @generated SignedSource<<9880419b167e47024df405e1025257de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionHeaderFeaturesArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "sectionHeaderFeaturesArticle";
};
export type sectionHeaderFeaturesArticle$key = {
  readonly " $data"?: sectionHeaderFeaturesArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionHeaderFeaturesArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sectionHeaderFeaturesArticle"
};

(node as any).hash = "056db405f0ceadcd98b78d231ba9da34";

export default node;
